enum ProjectsOrderBy {
  NAME = 'NAME',
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
}

export default ProjectsOrderBy;
